<div *ngIf=" websiteName == 'Major'" class="main-container">
    <div style="width: 100% !important;" *ngIf="cmsHelpResponse?.length > 0">
        <h2   class="title-header"    [innerHTML]="cmsHelpResponse?.[0].title"></h2>
        <p style="font-size: 14px" [ngStyle]="{'margin-bottom': isMobileDevice() ? '20px' :''}" [innerHTML]="cmsHelpResponse?.[0].description"></p>
    </div>
    <div class="cta-inner-container">
        <div  class="cta-major-box" *ngFor="let cta of cmsHelpResponse | slice:1; let i = index">
            <h2 class="cta-title">
                {{cta?.title}}
            </h2>
            <p class="cta-desc" [innerHTML]="cta?.description"></p>
            <button  class="cta-btn"  (click)="navigateToTargetLink(cta);" color="accent" mat-raised-button>{{cta?.Button}}
                <img src="/assets/images/mobile/Major/Download_btn_icon.png" class="download-icon" alt="" title="" />
            </button>
        </div>
    </div>
</div>
